export default __webpack_public_path__ + "static/media/portrait2.083ab15c.jpg";